import React from 'react';
import { DeleteForever } from '@mui/icons-material';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

const FromSchemeList = ({ 
    fromSchemeDetails, 
    fromSubheadsList, 
    screenType, 
    toggleNestedTable, 
    removeSubhead, 
    activity, 
    findSubActivitiesById, 
    fy_list, 
    expandedIndex, 
    totalAmount 
}) => {
    return (
        <div className="col-md-12">
            <h6 className="text-center mb-4" style={{ fontWeight: 'bold' }}>From Subhead</h6>
            <table className="table table-responsive" style={{ tableLayout: 'auto' }}>
                <thead>
                    <tr>
                        {fromSchemeDetails.is_activity_active == 1 && <th>#</th>}
                        <th>Scheme Name</th>
                        <th>Financial Year</th>
                        <th>Subhead Name</th>
                        {screenType != "View" && <th>Subhead Balance</th> }
                        <th>Reappropriation Amount</th>
                        {screenType != "View" && <th>Action</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        fromSubheadsList.length > 0 ?
                            fromSubheadsList.map((e, index) => {
                                const financial_year = fy_list.find(y => y.id == e.financial_year_id);
                                const isRowExpanded = expandedIndex === index;

                                return (
                                    <React.Fragment key={e.from_subhead_id}>
                                        <tr>
                                            {fromSchemeDetails.is_activity_active == 1 && <td><span onClick={() => toggleNestedTable(index)} style={{ cursor: 'pointer' }}>
                                                {isRowExpanded ? <BiChevronUp /> : <BiChevronDown />}
                                            </span></td>}
                                            <td>{fromSchemeDetails.scheme_name}</td>
                                            <td>{financial_year.start_year}-{financial_year.end_year}</td>
                                            <td>{e.subhead_name}</td>
                                            {screenType != "View" && <td>{e.subhead_balance}</td>}
                                            <td>{e.from_reappropriation_amount}</td>
                                            {screenType != "View" && <td>
                                                <button type="button"
                                                    className="btn btn-danger mx-2"
                                                    onClick={(e) => removeSubhead(index, 'from')}>
                                                    <DeleteForever /></button>
                                            </td>}
                                        </tr>

                                        {/* Nested Table */}
                                        {fromSchemeDetails.is_activity_active == 1 && isRowExpanded && (
                                            <tr>
                                                <td colSpan={6}>
                                                    <table className="table table-bordered mt-2">
                                                        <thead>
                                                            <tr>
                                                                <th>Activity</th>
                                                                <th>Subactivity</th>
                                                                {screenType != "View" && <th>Available Balance</th>}
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {e.activity && e.activity.length > 0 ? (
                                                                e.activity.map((activityItem, index) => (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <select
                                                                                className="form-control"
                                                                                name="activity_id"
                                                                                value={activityItem.activity_id}
                                                                                disabled={true}
                                                                            >
                                                                                <option value="">---Select---</option>
                                                                                {activity.map(a => (
                                                                                    <option key={a.id} value={a.id}>{a.activity}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        <td>
                                                                            <select
                                                                                className="form-control"
                                                                                name="subactivity_id"
                                                                                value={activityItem.subactivity_id}
                                                                                disabled={true}
                                                                            >
                                                                                <option value="">---Select---</option>
                                                                                {findSubActivitiesById(activityItem.activity_id).map(sa => (
                                                                                    <option key={sa.id} value={sa.id}>{sa.subactivity}</option>
                                                                                ))}
                                                                            </select>
                                                                        </td>
                                                                        {screenType != "View" &&<td>{e?.activity_budget && e?.activity_budget.length != 0 && e?.activity_budget.find(e =>
                                                                            e.subhead_activity_id === activityItem.activity_id &&
                                                                            e.subhead_subactivity_id === activityItem.subactivity_id
                                                                        )?.budget}</td>}
                                                                        <td>{activityItem?.budget}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={4} className="text-center">No Details Available</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                );
                            })
                            : <tr><td colSpan={6} className="text-center">No Data</td></tr>
                    }
                </tbody>

                <tfoot>
                    <tr>
                        <th colSpan={4}>Total Reappropriation Amount: </th>
                        <th>{totalAmount.current}</th>
                        {screenType != "View" && <th></th>}
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default FromSchemeList;